// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.songwriter-cards {
  gap: 5.7rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: 2.4rem 0;
}

.view-link {
  align-self: center;
}

.delete-songwriter-button {
  flex: 1;
  display: flex;
  justify-content: right;
  gap: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Cards/AccountCard/SongwriterAccountCards/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,qCAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACF","sourcesContent":[".songwriter-cards {\n  gap: 5.7rem;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  padding: 2.4rem 0;\n}\n\n.view-link {\n  align-self: center;\n}\n\n.delete-songwriter-button {\n  flex: 1;\n  display: flex;\n  justify-content: right;\n  gap: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
